const ls = require("local-storage");
let funcaoRole = JSON.parse(ls.get('FuncoesPorRole'));

class funcaoPorROle {
  verificarFuncao(idFuncao) {
    try {
      if (funcaoRole) {
        let isTrue = funcaoRole.filter((f) => f.id == idFuncao);
        return isTrue.length ? true : false;
      }
    } catch (error) {
      console.log(error);
    }
  }

  opcaoCertaPagamento() {
    try {
      // Filtra o array pelos objetos com idMenu == 2 e id no intervalo de 1 a 13
      let filtroMenu = funcaoRole.filter(f => f.idMenu == 2 && f.id >= 1 && f.id <= 13);
  
      // Verifica se existe um objeto com id == 10 (Tela pagamento)
      let id10 = filtroMenu.find(f => f.id == 10);
      if (id10) {
        return 10;
      } else {
        // Se não encontrar, retorna o maior id, excluindo 11, 12 e 9
        let maiorId = Math.max(
          ...filtroMenu
            .map(f => f.id)
            .filter(id => id !== 11 && id !== 12 && id !== 9)
        );
  
        // Verifica se conseguiu encontrar um maiorId válido
        if (isFinite(maiorId)) {
          return maiorId;
        } else {
          // Se não houver ID válido, retorna um valor padrão ou lança um erro
          console.error('Nenhum id válido encontrado no intervalo!');
          return null; // ou um valor padrão
        }
      }
    } catch (error) {
      console.error('Erro ao selecionar a opção de pagamento:', error);
      return null; // Retorna null em caso de erro
    }
  }
  
}

export default new funcaoPorROle();
